import BreadCrumbsBar from "./BreadCrumbsBar";
import Content from './Content';
import Header from './Header';

import './header.css';

class Layout {

}

Layout.Header = Header;
Layout.BreadCrumbsBar = BreadCrumbsBar;
Layout.Content = Content;

export {Layout};